import API_URLS from "@/constants/apiUrls";
import { HTTP_METHODS } from "@/constants/httpMethods";
import { request } from "@/lib/api";

/**
 * Bus Search Service
 * Otobüs arama API'leri için servis
 */
export const busSearchService = {
  /**
   * Otobüs otomatik tamamlama önerilerini getir
   * @param {string} term - Arama terimi (örn: "Ad")
   * @param {string} languageCode - Dil kodu (örn: "tr", "en")
   * @param {Object} headers - HTTP headers
   * @param {boolean} hasErrorHandler - Hata yönetimi aktif mi
   * @returns {Promise} API response
   * 
   * Usage Example:
   * autocomplete("Ad", "tr")
   * → GET /v1/meta/autocomplete/bus?term=Ad&languageCode=tr
   */
  autocomplete: (term = "", languageCode = "tr", headers = {}, hasErrorHandler = false) => {
    const queryParams = new URLSearchParams({
      term: term,
      languageCode: languageCode,
    });
    
    return request({
      method: HTTP_METHODS.GET,
      url: `${API_URLS.bus.search.autocomplete}?${queryParams.toString()}`,
      payload: {},
      headers,
      hasErrorHandler,
    });
  },
};
